module.exports = __webpack_public_path__ + "img/WP2023-Registration.53e4fc48.jpg";